import React from 'react'
import styled from 'styled-components'

import AppHeader from '../common/app-header'
import Footer from '../common/footer'

import Page, { PageProps } from './page'
import { up } from 'styled-breakpoints'

type AppPageProps = PageProps & {
    hideFooter?: boolean
    restricted?: boolean
    className?: string
}

const AppPage: React.FunctionComponent<AppPageProps> = ({ children, hideFooter, restricted, className, ...props}) => {
    if (restricted === undefined) {
        restricted = true
    }

    return (
        <AppPageReset shade hideSocial hideHeader consistentBg {...props}>
            <AppHeader />
            <Container className={className}>
                { restricted && <Wrapper>
                    { children }
                    </Wrapper>
                }
                { !restricted && children }
            </Container>
            { !hideFooter && <Bottom>
                <Footer />
            </Bottom> }
        </AppPageReset>
    )
}


const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    justify-items: center;

    padding-top: 72px; // to ignore the header

    height: 100%;
    width: 100%;

    ${up('tablet')} {
        padding-top: 80px;
    }
`

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    justify-items: start;
    align-items: start;

    height: 100%;
    width: 100%;

    padding: 32px 16px;

    ${up('tablet')} {
        padding: 64px 32px 0 32px;
    }

    ${up('desktop')} {
        width: 1024px;
        padding: 0;
        padding-top: 64px;
    }

    ${up('desktopBig')} {
        width: 1440px;
    }
`

const AppPageReset = styled(Page)`
    background: ${p => p.bgColor ? p.bgColor : p.theme.colors.bgService};
`

const Bottom = styled.div`
    display: grid;
    align-items: end;

    bottom: 0;
`

export default AppPage